import { c as _c } from "react/compiler-runtime";
import { AuthOptions } from '@newfront-insurance/ms-graph-auth';
import { useEffect, useState } from 'react';
import { useChatOverlayContext } from '../contexts/chat-overlay-context';
import { useMSGraphAuth } from '../contexts/ms-graph-context';

/**
 * Side-effect component that fetches the MS Graph token when Outlook Connect is enabled
 * and writes it to additionalContext, following the same pattern as OutlookChatPayload.
 *
 * Only active when:
 * - outlookConnectEnabled is true (user toggled it on in settings)
 * - useMSGraphAuth() context is available (MSGraphRoot is enabled)
 * - authState is LOGGED_IN
 * - graphClient is non-null (MSAL initialized after page reload)
 *
 * This component doesn't render anything — it only manages context.
 */
export function NavigatorGraphPayload() {
  const $ = _c(13);
  const {
    outlookConnectEnabled,
    setAdditionalContext
  } = useChatOverlayContext();
  const msGraphAuth = useMSGraphAuth();
  const [graphToken, setGraphToken] = useState(null);
  const graphClient = msGraphAuth?.graphClient ?? null;
  const isLoggedIn = msGraphAuth?.authState.state === AuthOptions.LOGGED_IN;
  const getAccessToken = msGraphAuth?.getAccessToken ?? null;
  let t0;
  if ($[0] !== getAccessToken || $[1] !== isLoggedIn || $[2] !== outlookConnectEnabled) {
    t0 = () => {
      if (!outlookConnectEnabled || !isLoggedIn || !getAccessToken) {
        setGraphToken(null);
        return;
      }
      let isMounted;
      isMounted = true;
      const resolveToken = async () => {
        ;
        try {
          const token = await getAccessToken();
          if (isMounted) {
            setGraphToken(token);
          }
        } catch (t1) {
          const error = t1;
          console.error("[NavigatorGraphPayload] Failed to get graph token:", error);
          if (isMounted) {
            setGraphToken(null);
          }
        }
      };
      resolveToken();
      return () => {
        isMounted = false;
      };
    };
    $[0] = getAccessToken;
    $[1] = isLoggedIn;
    $[2] = outlookConnectEnabled;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== getAccessToken || $[5] !== graphClient || $[6] !== isLoggedIn || $[7] !== outlookConnectEnabled) {
    t1 = [outlookConnectEnabled, isLoggedIn, getAccessToken, graphClient];
    $[4] = getAccessToken;
    $[5] = graphClient;
    $[6] = isLoggedIn;
    $[7] = outlookConnectEnabled;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[9] !== graphToken || $[10] !== setAdditionalContext) {
    t2 = () => {
      setAdditionalContext(prev => {
        if (!graphToken) {
          const {
            userGraphToken: _,
            ...rest
          } = prev as Record<string, unknown> & {
            userGraphToken?: string;
          };
          return rest;
        }
        return {
          ...prev,
          userGraphToken: graphToken
        };
      });
    };
    t3 = [setAdditionalContext, graphToken];
    $[9] = graphToken;
    $[10] = setAdditionalContext;
    $[11] = t2;
    $[12] = t3;
  } else {
    t2 = $[11];
    t3 = $[12];
  }
  useEffect(t2, t3);
  return null;
}